
import { components } from '~/slices'
import prismicCustomTypePageContent from '~/mixins/prismicCustomType/single'
import headData from '~/mixins/headData'
import {
  JOBS_URL,
  JOBS_EMBED_SCRIPT,
  getJobExcerpt,
  sanitizeHtml,
} from '@/utils/jobs'

const type = 'vacancy'
const theme = 'soft-white'

export default {
  name: 'JobPostPage',
  mixins: [prismicCustomTypePageContent({ type, theme }), headData],
  data() {
    return {
      contentSeparator: '\u0026lt;hr\u0026gt;',
      isLoading: true,
      error: null,
      jobData: null,
      components,
    }
  },
  async fetch() {
    await this.getJobData()
  },
  head() {
    return {
      script: [
        {
          hid: 'gh',
          src: JOBS_EMBED_SCRIPT,
          defer: false,
          body: true,
        },
      ],
    }
  },
  computed: {
    jobId() {
      return this.$route.params.jobId
    },
    jobTitle() {
      return this.jobData?.title
    },
    jobLocation() {
      return this.jobData?.location?.name
    },
    jobDescription() {
      return getJobExcerpt(this.jobData)
    },
    modalTitle() {
      return this.jobTitle ? `Apply for ${this.jobTitle}` : 'Apply'
    },
    firstContent() {
      if (this.isLoading || this.error) {
        return ''
      }

      const rawContent = this.jobData.content.split(this.contentSeparator)[0]

      if (rawContent) {
        return sanitizeHtml(rawContent)
      }

      return ''
    },
    secondContent() {
      if (this.isLoading || this.error) {
        return ''
      }

      const rawContent = this.jobData.content.split(this.contentSeparator)[1]

      if (rawContent) {
        return sanitizeHtml(rawContent)
      }

      return ''
    },
    legalInformation() {
      const legalInformation =
        this.document?.data['text-and-link-for-legal-data-processing']
      return legalInformation?.length > 0 && legalInformation
    },
    socialShare() {
      return [
        {
          network: 'twitter',
          title: this.jobTitle,
          description: this.jobDescription,
          url: window.location.href,
        },
        // {
        //   network: 'linkedin',
        //   title: this.jobTitle,
        //   description: this.jobDescription,
        //   url: window.location.href,
        // },
      ]
    },
  },
  fetchOnServer: false,
  methods: {
    async getJobData() {
      try {
        const { data } = await this.$axios.get(`${JOBS_URL}/${this.jobId}`)
        this.jobData = data
      } catch (err) {
        this.error = true
      } finally {
        this.isLoading = false
      }
    },
  },
}
